export default __webpack_public_path__ + "static/media/swt1.d7da52bd.svg";